export default __webpack_public_path__ + "static/media/pantry1-afterC-1024w.a54b01d3.avif";